import { Box, Grid, Typography } from "@material-ui/core";
import { useEffect, useReducer, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaAngleLeft, FaAngleRight, FaImage } from "react-icons/fa";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { BaseButton } from "../../componentes/baseComponents/BaseButton";
import DefaultButton from "../../componentes/button/DefaultButton";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import TagLayoutService from "./TagLayoutService";
import { Visibility } from "@material-ui/icons";

const columns = (t) => [
    {
        field: "id",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="id" name="id" />;
        },
    },
    {
        field: "clientId",
        textAlign: "center",
        visible: false,
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="clientId" name="clientId" />;
        },
    },
    {
        field: "clientName",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="client" name="client" />;
        },
    },
    {
        field: "description",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="description" name="description" />;
        },
    },
    {
        field: "cdStatus",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        width: 150,
        template: (props) => {
            return (
                <>
                    {props.cdStatus === 1 ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const TagLayout = (props) => {

    const { t } = useTranslation();
    const { control } = useForm();
    const loggedUserId = sessionStorage.getItem("userId");
    const [direction, setDirection] = useState(180);
    const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);

    const initialState = {
        id: 0,
        idClient: loggedIdClient !== 0 ? loggedIdClient : 0,
        description: "",
        tag: "",
        userId: loggedUserId,
        success: false,
        error: false,
        message: "",
        rows: [],
        preview: false,
        cdStatus: 1,
    }

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const {
        id,
        idClient,
        description,
        tag,
        userId,
        success,
        error,
        message,
        rows,
        preview,
        cdStatus,
    } = state;

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } })
    }

    const handleSearch = () => {
        const request = { ...state, clientId: idClient, Description: description, CdStatus: cdStatus }
        TagLayoutService
            .get(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }
    const canSave = () => description !== "" && idClient !== 0 && tag !== "" && cdStatus !== 2;

    const handleSaveUpdate = () => {
        if (canSave()) {
            const request = { ...state, clientId: idClient }
            if (id) {
                TagLayoutService
                    .update(request)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                TagLayoutService
                    .create(request)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'update', data: { success: true, error: false, id: response.data.id, message: t("saveSuccess") } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }

    }

    const handleCellClick = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                idClient: data.clientId,
                description: data.description,
                tag: data.tag,
                cdStatus: data.cdStatus
            }
        })
    }


    useEffect(() => {
        handleSearch();
    }, [])

    return (

        <DefaultScreenAccordion
            title={"tagLayout"}
            isRegister
            fields={
                <>
                    <GridItemContainer>
                        <CustomAlert
                            success={success}
                            error={error}
                            message={message}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                            snackbar
                            autoClose
                        />
                        <GridInputRow>
                            <Grid item xs={12} sm={6} md={3}>
                                <div style={{
                                    pointerEvents: loggedIdClient !== 0 ? "none" : "auto",
                                    opacity: loggedIdClient !== 0 ? 0.8 : 1
                                }}>

                                    <DefaultAutocomplete
                                        iconLabelSwitch={
                                            <IconLabelSwitch
                                                name={loggedIdClient !== 0 ? "unLock" : "user"}
                                                labelName="client"
                                            />
                                        }
                                        name="idClient"
                                        onChange={loggedIdClient !== 0 ? undefined : handleChange}
                                        disabled={loggedIdClient !== 0}
                                        value={idClient}
                                        defaultSize
                                        useApi
                                        endpoint='GetClient'
                                        error={error && idClient === 0}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <InputField
                                    iconLabelSwitch={
                                        <IconLabelSwitch name="description" labelName="description" />
                                    }
                                    name="description"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={description}
                                    length={50}
                                    error={error && description === ""}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <DefaultAutocomplete
                                    name="cdStatus"
                                    onChange={handleChange}
                                    value={cdStatus}
                                    label={t("status")}
                                    defaultSize
                                    items={[
                                        { id: 0, name: t("canceled"), status: 1 },
                                        { id: 1, name: t("active"), status: 1 },
                                        { id: 2, name: t("all"), status: 1 },
                                    ]}
                                    error={error && cdStatus === 2}
                                />
                            </Grid>
                        </GridInputRow>
                        <GridInputRow>
                            <Grid item xs={6}>
                                <InputField
                                    iconLabelSwitch={
                                        <IconLabelSwitch name="tag" labelName="tag" />
                                    }
                                    name="tag"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={tag}
                                    rows={35}
                                    rowsMax={35}
                                    multiline
                                    error={error && tag === ""}
                                />
                            </Grid>

                            {preview ? (
                                <Grid
                                    item
                                    xs={6}
                                    direction="column"
                                    align="center"
                                >
                                    <Typography>{t("tagPreview")}</Typography>
                                    {tag ? (
                                        <>
                                            <Box width="100%">
                                                <img
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        transform: `rotate(${direction}deg)`,
                                                    }}
                                                    src={"http://api.labelary.com/v1/printers/8dpmm/labels/4x4/0/" + encodeURIComponent(tag)}
                                                    alt={'Largura e Comprimento Máximos 381 mm'}
                                                />
                                            </Box>
                                            <FaAngleLeft
                                                size={30}
                                                color={"#2357ac"}
                                                onClick={() => setDirection(direction - 90)}
                                            />
                                            <FaAngleRight
                                                size={30}
                                                color={"#2357ac"}
                                                onClick={() => setDirection(direction + 90)}
                                            />
                                        </>
                                    ) : (
                                        <div style={{ height: "100px" }}>
                                            <FaImage
                                                style={{ height: "100px", color: "grey" }}
                                                size
                                            />
                                        </div>
                                    )}
                                </Grid>
                            ) : null}
                        </GridInputRow>
                        <SearchClearSaveRow
                            onClickSearch={handleSearch}
                            onClickSave={handleSaveUpdate}
                            onClickClear={() => dispatch({ type: 'clear' })}
                            customButtons={
                                <>
                                    {tag !== "" && (
                                        <Grid>
                                            <DefaultButton
                                                className="primaryButton"
                                                onClick={() => dispatch({ type: 'update', data: { preview: preview ? false : true } })}
                                                labelName={t("preview")}
                                            />
                                        </Grid>
                                    )}
                                </>
                            }
                        />
                    </GridItemContainer>

                    {rows.length > 0 ? (
                        <DefaultDatagrid
                            dataSource={rows}
                            columns={columns(t)}
                            allowPaging={true}
                            cellSelected={(selected) => {
                                handleCellClick(selected.data);
                            }}
                        />
                    ) : null}
                </>
            } />
    )
}